import React from 'react';
import { Box, Select, Text } from 'grommet';
import PropTypes from 'prop-types';

// Rows-per-page picker shown alongside table Pagination. Emits Grommet
// Select's `{ option }` change shape so callers can `setPageSize(option)`.
export const RowsPerPageSelect = ({
    options,
    value,
    onChange,
    label = 'Rows per page',
}) => (
    <Box direction="row" align="center" gap="xsmall">
        <Text size="small">{label}</Text>
        <Select
            a11yTitle={label}
            options={options}
            value={value}
            onChange={onChange}
            size="small"
        />
    </Box>
);

RowsPerPageSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.number).isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
};
